(function () {
  function refreshInventoryNotice(productSection, variantId) {
    if (!productSection || !variantId) return;

    var currentNotice = productSection.querySelector('.product-inventory');
    var sectionId = productSection.getAttribute('data-section-id');

    if (!currentNotice || !sectionId) return;

    fetch(window.location.pathname + '?variant=' + variantId + '&section_id=' + sectionId)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var updatedNotice = doc.querySelector('.product-inventory');
        var liveNotice = productSection.querySelector('.product-inventory');

        if (updatedNotice && liveNotice) {
          liveNotice.outerHTML = updatedNotice.outerHTML;
        } else if (liveNotice) {
          liveNotice.style.display = 'none';
        }
      })
      .catch(function (err) {
        console.error('Inventory notice update failed:', err);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    var variantInput = productSection.querySelector('[name="id"]');
    if (!variantInput) return;

    // Initial load
    if (variantInput.value) {
      refreshInventoryNotice(productSection, variantInput.value);
    }

    // Watch for programmatic value changes on the variant input
    var lastVariantId = variantInput.value;
    setInterval(function () {
      var currentId = variantInput.value;
      if (currentId && currentId !== lastVariantId) {
        lastVariantId = currentId;
        refreshInventoryNotice(productSection, currentId);
      }
    }, 200);
  });
})();
